import React, { Component } from 'react'; 
import IndexRubros from '../index/IndexRubros'; 
import indexAnteriores from '../index/indexAnteriores'; 

class Rubros extends Component{ 

    componentDidMount(){    
      window.startx();
    }

    render(){ 
      return (
        <div id="page-wrapper">
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>48 Rubros</h2>
              </header>
              <div className="box alt center ">
                <div className="row gtr-uniform iconosareas2 ocultar">
                  { this._renderCard() }
                </div>
              </div>
              <header className="major">
                <h2>Información de Ejercicios Anteriores.69 (48 Fracciones)</h2>
                <div>
                  <h3 >
                    <a data-toggle="collapse" href="#collapse1">Ver Ejercicios Anteriores</a>
                  </h3>
                  {this._renderCardAnt()}
                </div>
              </header>
            </div>
          </div>
        </div>
      ); 
    };

    _renderCardAnt = (label) => {
    const arr = indexAnteriores.anteriores;
    return arr.map((data, j) => {  
      return ( 
        <div id={data.id}> 
          <div id="collapse1" class="panel-collapse collapse">
            <h4 class="panel-title">
              <a data-toggle="collapse" href={"#collapse1_1"+data.id}>{data.anio}</a>
            </h4>
          </div>
          <div id={"collapse1_1"+data.id} class="panel-collapse collapse">
            <h5 class="panel-title" style={{display: data.trimestre1 === ""?"none":"block" }}>
              <a href={data.trimestre1}>Primer Trimestre</a>
            </h5>
          </div>
          <div id={"collapse1_1"+data.id} class="panel-collapse collapse">
            <h5 class="panel-title" style={{display: data.trimestre2 === ""?"none":"block" }}>
              <a href={data.trimestre2}>Segundo Trimestre</a>
            </h5>
          </div>
          <div id={"collapse1_1"+data.id} class="panel-collapse collapse">
            <h5 class="panel-title" style={{display: data.trimestre3 === ""?"none":"block" }}>
              <a href={data.trimestre3}>Tercer Trimestre</a>
            </h5>
          </div>
          <div id={"collapse1_1"+data.id} class="panel-collapse collapse">
            <h5 class="panel-title" style={{display: data.trimestre4 === ""?"none":"block" }}>
              <a href={data.trimestre4}>Cuarto Trimestre</a>
            </h5>
          </div>
        </div>     
      );
    });
  };

     _renderCard = (label) => {
    const arr = IndexRubros.rubros;
    return arr.map((data, j) => {
      let targ = "_self";
      let url = "/rubro/"+j; //agregar #/ aqui para usar HashRouter  
      if(j === 11){
        url= "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%BAblicas";
        targ = "_blank";
      };      
      if(j === 12){
        url= "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad";
        targ = "_blank";
      };      
      if(j === 13){
        url= "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/14.%20Convocatorias";
        targ = "_blank";
      };  
      if(j === 15){
        url= "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/16.%20Relaciones%20Laborales";
        targ = "_blank";
      };      
      if(j === 17){
        url= "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas";
        targ = "_blank";
      };      
      if(j === 21){
        url= "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%BAblica";
        targ = "_blank";
      };
      if(j === 23){
        url= "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%ADas";
        targ = "_blank";
      };      
      /*if(j === 25){
        url= "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Asignaci%C3%B3n%20de%20Recursos%20P%C3%BAblicos%20a%20Personas";
        targ = "_blank";
      }; */
      if(j === 31){
        url= "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas";
        targ = "_blank";
      };      
      if(j === 35){
        url= "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/36.%20Resoluciones%20y%20Laudos%20de%20Juicios";
        targ = "_blank";
      };      
      if(j === 37){
        url= "https://s-salud.hidalgo.gob.mx/Transparencia/RubrosSsh/DetalleRubroSsh/38.%20Programas%20Ofrecidos";
        targ = "_blank";
      };
      if(j === 38){
        url= "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia";
        targ = "_blank";
      };
      if(j === 39){
        url= "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/40.Evaluacion%20y%20Encuestas%20a%20Programas%20Financiados%20con%20Recursos%20P%C3%BAblicos";
        targ = "_blank";
      };
      if(j === 40){
        url= "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/41.Estudios%20Pagados%20con%20Recursos%20P%C3%BAblicos";
        targ = "_blank";
      };
      if(j === 41){
        url= "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/42.%20Listados%20Jubilados%20y%20Pensionados";
        targ = "_blank";
      };
      if(j === 45){
        url= "https://s-turismo.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/46.Actas%20de%20Sesiones,%20Opiniones%20y%20Recomendaciones%20de%20Consejos%20Consultivos";
        targ = "_blank";
      };
      if(j === 46){
        url= "https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervenci%C3%B3n%20de%20%20Comunicaciones";
        targ = "_blank";
      };
      return (       
        <a href={url} target={targ} className="col-md-2 col-sm-6 col-12 ocultar">
          <span className="icon alt major"><img src={"http://cdn.hidalgo.gob.mx/plantilla_secretarial/Rubros/PNG/"+data.icono} alt="Icono"></img></span>
          <h3>{ j + 1 }. { data.nombre }</h3>
        </a>
      );
    });
  };

}

  export default Rubros;